import { SocialNetworkGroupModel } from '.'
import { isUnknownObject } from '~/shared/utils/guards'
import { BaseModel, convertToArrayModels, fillOwnProperties } from '~/shared/model'

export default class SocialNetworkModel extends BaseModel {
  static override constructorName = 'SocialNetworkModel'

  public id: number = 0
  public name: string = ''
  public type: string = ''
  public activateUrl: string = ''
  public isActivated: boolean = false
  public tokenStoreUrl: string = ''
  public groups: Array<SocialNetworkGroupModel> = []

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      this.groups = convertToArrayModels(data.users_socials_groups, SocialNetworkGroupModel)
    }
  }
}
